(function (angular) {
    'use strict';

    angular.module('app')
        .filter('prettyDate', prettyDate);

    // prettyDate.$inject = [];

    function prettyDate(
    ) {
        return function prettyDateFilter(date, optionalEndDate, shortFormat) {
            date = window.moment.tz(date, 'UTC').tz('Europe/London');

            var parts = [],
                endDate = (optionalEndDate ? window.moment.tz(optionalEndDate, 'UTC').tz('Europe/London') : false),
                formats = {
                    fullDay: shortFormat ? 'DD/MM/YYYY' : 'dddd Do MMM Y',
                    fullTime: shortFormat ? ' @ HH:mm' : ' (h:mm a)',
                };

            if (!endDate) {
                parts.push(date.format(formats.fullDay));
                // parts.push(' (');
                parts.push(date.format(formats.fullTime));
                // parts.push(')');
            } else {
                if (date.format(formats.fullDay) === endDate.format(formats.fullDay)) {
                    // both dates are the same day
                    parts.push(date.format(formats.fullDay));
                    // parts.push(' (');
                    parts.push(date.format(formats.fullTime));
                    parts.push(' until ');
                    parts.push(endDate.format(formats.fullTime));
                    // parts.push(')');
                } else {
                    parts.push(date.format(formats.fullDay + ' ' + formats.fullTime));
                    parts.push(' - ');
                    parts.push(endDate.format(formats.fullDay + ' ' + formats.fullTime));
                }
            }

            parts.forEach(function (part, i) {
                if (part === 'Invalid date') {
                    parts[i] = 'Unknown';
                }
            });

            return parts.join('');
        };
    }

}(angular));
